/* Smile Patches quiz engine. Content lives in snippets/sp-quiz-config.liquid (window.SPQ_CONFIG).
   Answers stay in this browser (sessionStorage); nothing is sent to pixels or Klaviyo. */
(function () {
  var C = window.SPQ_CONFIG, root = document.getElementById('spq');
  if (!C || !root) return;
  var S = C.screens, KEY = 'spq_state_v1', OUT = 'spq_result_v1';
  var st = load() || { i: 0, a: {} };
  var stage = root.querySelector('.spq-stage'), bar = root.querySelector('.spq-bar-cta'),
      cta = root.querySelector('.spq-cta'), back = root.querySelector('.spq-back'),
      prog = root.querySelector('.spq-progress__bar'), count = root.querySelector('.spq-count');
  var cur = null, busy = false, loaderTimer = null, depth = 0;

  function load() { try { return JSON.parse(sessionStorage.getItem(KEY)); } catch (e) { return null; } }
  function save() { try { sessionStorage.setItem(KEY, JSON.stringify(st)); } catch (e) {} }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function track(name) { try { window.Shopify && Shopify.analytics && Shopify.analytics.publish(name, {}); } catch (e) {} }
  function byId(id) { for (var k = 0; k < S.length; k++) if (S[k].id === id) return S[k]; return null; }
  function opt(id, v) { var s = byId(id); if (!s || !s.options) return null; for (var k = 0; k < s.options.length; k++) if (s.options[k].v === v) return s.options[k]; return null; }
  function visible(k) { var c = S[k] && S[k].if; if (!c) return true; for (var key in c) { var want = [].concat(c[key]), got = st.a[key]; if (want.indexOf(got) < 0) return false; } return true; }
  // for the progress counter: before a branch is chosen, count it as if the first branch were picked
  function countable(k) { var c = S[k] && S[k].if; if (!c) return true; for (var key in c) { var got = st.a[key]; if (got == null) { var o = (byId(key) || {}).options; got = o && o[0].v; } if ([].concat(c[key]).indexOf(got) < 0) return false; } return true; }
  function step(from, dir) { var k = from + dir; while (k >= 0 && k < S.length && !visible(k)) k += dir; return k; }
  function gender() { return st.a.gender === 'm' ? 'm' : 'f'; }
  function num(v) { return String(Math.round(v * 10) / 10).replace('.', ','); }

  /* ---------- derived values ---------- */
  function calc() {
    var a = st.a, b = a.body || {}, h = +b.h, kg = +b.kg, goal = +((a.target || {}).goal);
    var bmi = h && kg ? kg / Math.pow(h / 100, 2) : 0;
    var diff = kg && goal ? Math.round(kg - goal) : 0;
    var pts = { evening: 0, afternoon: 0, stress: 0, grazing: 0, sweet: 0, metab: 0 }, sev = 0, sevMax = 0;
    S.forEach(function (s, idx) {
      if (!s.options || !visible(idx)) return;
      var ans = a[s.id], list = Array.isArray(ans) ? ans : ans != null ? [ans] : [];
      var maxS = 0; s.options.forEach(function (o) { if (o.s) maxS = s.type === 'multi' ? maxS + o.s : Math.max(maxS, o.s); });
      if (s.type === 'multi') maxS = Math.min(maxS, 3);
      var got = 0;
      list.forEach(function (v) { var o = opt(s.id, v); if (!o) return; got += o.s || 0; if (o.p) for (var t in o.p) pts[t] += o.p[t]; });
      sev += Math.min(got, maxS); sevMax += maxS;
    });
    var score = sevMax ? Math.round(sev / sevMax * 100) : 50;
    // bars: each dimension from its own answers → 25–95%
    var dims = [];
    for (var dk in (C.dims || {})) {
      // first source = the direct question (70%), the rest add context (30%)
      var D = C.dims[dk], pr = null, sr = 0, sm = 0, first = true;
      if (D.if && !okIf(D.if)) continue;
      for (var sid in D.from) {
        var k = S.indexOf(byId(sid));
        if (k < 0 || !visible(k)) continue;
        var isFirst = first; first = false;
        var m = D.from[sid], mx = 0, got = 0, val = a[sid], vals = Array.isArray(val) ? val : val != null ? [val] : [];
        for (var ov in m) mx = (byId(sid) || {}).type === 'multi' ? mx + m[ov] : Math.max(mx, m[ov]);
        vals.forEach(function (v) { got += m[v] || 0; });
        if (isFirst) pr = mx ? Math.min(1, got / mx) : 0; else { sr += got; sm += mx; }
      }
      if (pr === null && !sm) continue;
      var ratio = pr === null ? sr / sm : sm ? 0.7 * pr + 0.3 * Math.min(1, sr / sm) : pr;
      dims.push({ key: dk, name: D.name, type: D.type, pct: Math.round(25 + ratio * 70) });
    }
    dims.sort(function (x, y) { return y.pct - x.pct; });
    // profile = strongest bar that drives a profile (ties → old points)
    // time-bound profiles only when "when" agrees (no "evening" profile for someone hungry in the afternoon)
    var TB = { evening: ['evening', 'night'], afternoon: ['afternoon'] }, type = null, best = -1;
    dims.forEach(function (x) {
      if (!x.type || (TB[x.type] && TB[x.type].indexOf(a.when) < 0)) return;
      if (x.pct > best || (x.pct === best && pts[x.type] > pts[type])) { best = x.pct; type = x.type; }
    });
    if (!type) type = { afternoon: 'afternoon', evening: 'evening', night: 'evening', allday: 'grazing' }[a.when] || 'evening';
    // gauge: Yavor's level % as anchors, smooth inside each band
    var L = C.levels, li = 0; L.forEach(function (l, j) { if (score >= l.min) li = j; });
    var lo = L[li], hi = L[li + 1], top = hi ? hi.pct : Math.min(97, lo.pct + 7), span = (hi ? hi.min : 100) - lo.min;
    var gpct = Math.round(lo.pct + (top - lo.pct) * Math.min(1, (score - lo.min) / span));
    return { h: h, kg: kg, goal: goal, bmi: bmi, diff: diff, type: type, score: score, level: lo, gpct: gpct, dims: dims };
  }
  // big goals are split: the plan covers a first stage of max. ~21 weeks; minimum 12 weeks
  function planStage(d) { var r = C.rateKgPerWeek || 0.7; return d.diff > 0 ? Math.min(d.diff, Math.round(21 * r)) : 0; }
  function planWeeks(d) { var r = C.rateKgPerWeek || 0.7; return d.diff > 0 ? Math.max(12, Math.min(21, Math.round(planStage(d) / r))) : 12; }
  function bmiLabel(b) { return b < 18.5 ? 'под нормата' : b < 25 ? 'в нормата' : b < 30 ? 'над нормата' : 'доста над нормата'; }

  /* ---------- text tokens ---------- */
  function tx(str) {
    if (!str) return '';
    var g = gender(), d = calc();
    str = str.replace(/\[\[([^|\]]*)\|([^\]]*)\]\]/g, function (_, f, m) { return g === 'm' ? m : f; });
    return str.replace(/\{(say:|res:)?(\w+)\}/g, function (_, say, k) {
      if (say) { var key = say.slice(0, -1), o = opt(k, st.a[k]); if (!o) return ''; var val = d.diff <= 0 && o[key + '_nogoal'] ? o[key + '_nogoal'] : o[key]; return val ? tx(val) : ''; }
      if (k === 'when') { var w = opt('when', st.a.when); return w ? w.t : 'вечер'; }
      if (k === 'tempt') { var t = opt('tempt', st.a.tempt); return t ? t.t : 'сладко'; }
      if (k === 'tried') {
        var l = (st.a.tried || []).map(function (v) { var o = opt('tried', v); return o && o.t; }).filter(Boolean);
        return l.length > 1 ? l.slice(0, -1).join(', ') + ' и ' + l[l.length - 1] : l[0] || 'диети';
      }
      if (k === 'diff') return Math.abs(d.diff);
      if (k === 'goal') return d.goal || '';
      if (k === 'kg') return d.kg || '';
      if (k === 'bmi') return num(d.bmi);
      if (k === 'type') return C.types[d.type].name;
      if (k === 'weeks') return planWeeks(d);
      if (k === 'stage') return planStage(d);
      if (k === 'stagekg') return d.kg - planStage(d);
      if (k === 'minkg') return d.h ? Math.ceil(18.5 * Math.pow(d.h / 100, 2)) : '';
      return '';
    });
  }

  /* ---------- screen builders ---------- */
  function optHtml(s, o) {
    var sel = isSel(s, o.v), role = s.type === 'multi' ? 'checkbox' : 'radio';
    if (s.type === 'photo') {
      var src = typeof o.img === 'object' ? o.img[gender()] : o.img;
      return '<button type="button" class="spq-opt spq-opt--photo' + (sel ? ' is-selected' : '') + '" role="radio" aria-checked="' + sel + '" data-v="' + esc(o.v) + '">' +
        '<img class="spq-opt__img" src="' + esc(src) + '" alt="" width="600" height="600"' + (st.i < 2 ? '' : ' loading="lazy"') + '><span class="spq-opt__label">' + esc(tx(o.l)) + '</span></button>';
    }
    return '<button type="button" class="spq-opt' + (sel ? ' is-selected' : '') + '" role="' + role + '" aria-checked="' + sel + '" data-v="' + esc(o.v) + '">' +
      (o.e ? '<span class="spq-opt__emoji">' + o.e + '</span>' : '') +
      '<span class="spq-opt__text"><span class="spq-opt__label">' + esc(tx(o.l)) + '</span>' + (o.h ? '<span class="spq-opt__hint">' + esc(tx(o.h)) + '</span>' : '') + '</span>' +
      '<span class="spq-opt__check"></span></button>';
  }
  function okIf(c) { if (!c) return true; for (var key in c) if ([].concat(c[key]).indexOf(st.a[key]) < 0) return false; return true; }
  function opts(s) { return s.options.filter(function (o) { return okIf(o.if); }); }
  function isSel(s, v) { var a = st.a[s.id]; return Array.isArray(a) ? a.indexOf(v) > -1 : a === v; }
  function head(s) {
    return (s.kicker ? '<p class="spq-kicker">' + esc(tx(s.kicker)) + '</p>' : '') +
      (s.title ? '<h1 class="spq-title">' + esc(tx(s.title)) + '</h1>' : '') +
      (s.sub ? '<p class="spq-sub">' + esc(tx(s.sub)) + '</p>' : '');
  }
  function listHtml(items) {
    return '<ul class="spq-list">' + items.map(function (it) { return '<li class="spq-list__item spq-list__item--' + it[0] + '">' + tx(it[1]) + '</li>'; }).join('') + '</ul>';
  }
  function reviewsHtml() {
    return (C.reviews || []).map(function (r) {
      return '<blockquote class="spq-review"><div class="spq-stars">★★★★★</div><p>„' + esc(r.text) + '“</p><cite>' + esc(r.name) + '</cite></blockquote>';
    }).join('');
  }

  function insightsHtml() {
    var out = [];
    (C.insights || []).forEach(function (id) {
      var k = S.indexOf(byId(id)); if (k < 0 || !visible(k)) return;
      if (id === 'tried') { var tr = (st.a.tried || []).filter(function (v) { return v !== 'none'; }); if (tr.length) out.push(tx('Опитвал[[а|]] си {tried}, без трайна промяна.')); return; }
      [].concat(st.a[id] || []).forEach(function (v) { var o = opt(id, v); if (o && o.r) out.push(tx(o.r)); });
    });
    if (!out.length) return '';
    return '<div class="spq-card"><h2 class="spq-card__title">Какво видяхме в отговорите ти</h2><ul class="spq-list">' +
      out.slice(0, 6).map(function (x) { return '<li class="spq-list__item spq-list__item--dot">' + esc(x) + '</li>'; }).join('') + '</ul></div>';
  }
  function build(s) {
    var d = calc(), h = '';
    switch (s.type) {
      case 'single': case 'multi':
        h = head(s) + '<div class="spq-opts">' + opts(s).map(function (o) { return optHtml(s, o); }).join('') + '</div>'; break;
      case 'photo':
        h = head(s) + '<div class="spq-opts spq-opts--grid">' + opts(s).map(function (o) { return optHtml(s, o); }).join('') + '</div>' +
          (s.trust ? '<ul class="spq-trust">' + s.trust.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul>' : ''); break;
      case 'input':
        var val = st.a[s.id] || {};
        h = head(s) + s.fields.map(function (f) {
          return '<div class="spq-fields" data-k="' + f.k + '"><label class="spq-field"><span class="spq-field__label">' + esc(f.l) + '</span>' +
            '<span class="spq-field__box"><input class="spq-input" type="text" inputmode="numeric" pattern="[0-9]*" maxlength="3" autocomplete="off" placeholder="' + f.ph + '" value="' + (val[f.k] || '') + '" data-k="' + f.k + '"><span class="spq-unit">' + f.unit + '</span></span></label>' +
            '<p class="spq-field__error">' + esc(f.err) + '</p></div>';
        }).join('') + (s.live ? '<p class="spq-sub spq-live" aria-live="polite"></p>' : ''); break;
      case 'echo':
        var ng = d.diff <= 0 && s.title_nogoal, big = !ng && d.diff > planStage(d) && s.title_big, img = s.img ? (typeof s.img === 'object' ? s.img[st.a.when] || s.img.evening : s.img) : '';
        h = '<div class="spq-card spq-card--echo">' + (img ? '<img class="spq-card__img" src="' + esc(img) + '" alt="">' : '') +
          (s.badge ? '<span class="spq-badge">' + esc(tx(s.badge)) + '</span>' : '') +
          '<h2 class="spq-card__title">' + esc(tx(ng ? s.title_nogoal : big ? s.title_big : s.title)) + '</h2><p class="spq-card__text">' + tx(ng ? s.text_nogoal : big ? s.text_big : s.text) + '</p></div>'; break;
      case 'edu':
        var tried = st.a.tried || [], nothing = !tried.length || tried.indexOf('none') > -1;
        var eimg = s.img ? (typeof s.img === 'object' ? s.img[st.a.when] || s.img.evening : s.img) : '';
        h = '<div class="spq-card spq-card--edu">' + (eimg ? '<img class="spq-card__img" src="' + esc(eimg) + '" alt="">' : '') +
          (s.badge ? '<span class="spq-badge">' + esc(tx(s.badge)) + '</span>' : '') +
          '<h2 class="spq-card__title">' + esc(tx(nothing && s.title_nothing ? s.title_nothing : s.title)) + '</h2>' +
          (s.text ? '<p class="spq-card__text">' + tx(nothing && s.text_nothing ? s.text_nothing : s.text) + '</p>' : '') +
          (s.cycle ? '<div class="spq-cycle">' + s.cycle.map(function (c) { return '<div class="spq-cycle__step"><span>' + c[0] + '</span>' + esc(tx(c[1])) + '</div>'; }).join('') + '</div>' : '') +
          (s.list ? listHtml(s.list) : '') + '</div>'; break;
      case 'proof':
        h = '<div class="spq-card spq-card--proof">' + (s.badge ? '<span class="spq-badge">' + esc(s.badge) + '</span>' : '') +
          '<h2 class="spq-card__title">' + esc(tx(s.title)) + '</h2>' + (s.list ? listHtml(s.list) : '') + reviewsHtml() +
          (C.rating && C.ratingCount ? '<div class="spq-stat"><strong>' + esc(C.rating) + '/5</strong><span>средна оценка от ' + esc(C.ratingCount) + ' отзива в Judge.me</span></div>' : '') +
          '</div><p class="spq-disclaimer">Резултатите са индивидуални.</p>'; break;
      case 'loader':
        h = '<h1 class="spq-title" style="text-align:center">' + esc(tx(s.title)) + '</h1><div class="spq-loader"><div class="spq-ring" style="--p:0"><span class="spq-ring__pct">0%</span></div>' +
          '<ul class="spq-steps">' + s.steps.map(function (x) { return '<li class="spq-step">' + esc(tx(x)) + '</li>'; }).join('') + '</ul></div>'; break;
      case 'result':
        var T = C.types[d.type], L = d.level;
        var own = d.dims.filter(function (x) { return x.type === d.type; })[0], shown = d.dims.slice(0, 4);
        if (own && shown.indexOf(own) < 0) shown[3] = own;
        var bars = d.dims.length ? shown.map(function (x) { return [x.name, x.pct, x === own]; }) : T.bars.map(function (b, k) { return [b[0], k === 0 ? L.pct : Math.min(b[1], L.pct - 3)]; });
        h = '<div class="spq-result"><p class="spq-result__label">Твоят профил</p><h2 class="spq-result__type">„' + esc(T.name) + '“</h2>' +
          '<div class="spq-gauge" style="--v:' + d.gpct + '"><span class="spq-gauge__value">' + d.gpct + '%</span><span class="spq-gauge__caption">' + esc(L.name.toLowerCase()) + ' ниво на изкушенията</span></div>' +
          '<div class="spq-bars">' + bars.map(function (b, k) {
            return '<div class="spq-bar' + (b[2] || k === 0 ? ' is-high' : '') + '" style="--v:' + b[1] + '"><span class="spq-bar__name">' + esc(b[0]) + '</span><span class="spq-bar__val">' + b[1] + '%</span></div>';
          }).join('') + '</div>' +
          (d.bmi ? '<div class="spq-metrics"><div class="spq-metric"><span>ИТМ</span><strong>' + num(d.bmi) + '</strong><em>' + bmiLabel(d.bmi) + '</em></div>' +
            (d.diff > 0 ? '<div class="spq-metric"><span>До целта</span><strong>−' + d.diff + ' кг</strong><em>от ' + d.kg + ' до ' + d.goal + ' кг</em></div>'
                        : '<div class="spq-metric"><span>Целта ти</span><strong>По-малко</strong><em>изкушения всеки ден</em></div>') + '</div>' : '') +
          (tx('{res:why}') ? '<p class="spq-result__text">' + esc(tx('{res:why}')) + '</p>' : '') + '<p class="spq-result__text">' + esc(tx(T.text)) + '</p><p class="spq-result__text">' + esc(tx(L.line)) + '</p></div>' + insightsHtml() +
          '<p class="spq-disclaimer">Резултатът е ориентировъчен и не е медицинска оценка.</p>'; break;
      case 'plan':
        var ng2 = d.diff <= 0, big2 = !ng2 && d.diff > planStage(d) && s.title_stage;
        var psub = big2 ? s.sub_stage : s.sub;
        h = '<h1 class="spq-title">' + esc(tx(ng2 ? s.title_nogoal : big2 ? s.title_stage : s.title)) + '</h1>' + (psub ? '<p class="spq-sub">' + esc(tx(psub)) + '</p>' : '') +
          '<div class="spq-plan"><div class="spq-chart">' + chart(d) + '</div><ol class="spq-timeline">' +
          s.timeline.map(function (t) { return '<li class="spq-tl"><span class="spq-tl__when">' + esc(tx(t[0])) + '</span><strong class="spq-tl__title">' + esc(tx(t[1])) + '</strong><p>' + esc(tx(t[2])) + '</p></li>'; }).join('') +
          '</ol></div><div class="spq-card"><h2 class="spq-card__title">Твоят ден с лепенката</h2><ul class="spq-list">' +
          s.daily.map(function (x) { return '<li class="spq-list__item spq-list__item--dot">' + x[0] + ' ' + esc(tx(x[1])) + '</li>'; }).join('') + '</ul></div>' +
          '<p class="spq-disclaimer">Резултатите са индивидуални. Графиката е примерна.</p>'; break;
    }
    return h;
  }

  /* illustrative line chart: weight (or craving level when there is no weight goal) */
  function chart(d) {
    var hasGoal = d.diff > 0, weeks = planWeeks(d), tgt = d.kg - planStage(d);
    var top = hasGoal ? d.kg + 1 : 100, bot = hasGoal ? tgt - 1 : 20, y = function (v) { return 30 + (top - v) / (top - bot) * 150; };
    var y0 = y(hasGoal ? d.kg : d.gpct), y1 = y(hasGoal ? tgt : 35), yf = y(hasGoal ? d.kg + 0.6 : d.gpct + 4);
    var ticks = hasGoal ? [d.kg, Math.round((d.kg + tgt) / 2), tgt] : [d.gpct, 35];
    return '<svg viewBox="0 0 400 210" role="img" aria-label="Примерна графика">' +
      '<g stroke="#E3EBF4" stroke-width="1"><line x1="34" y1="30" x2="390" y2="30"/><line x1="34" y1="80" x2="390" y2="80"/><line x1="34" y1="130" x2="390" y2="130"/><line x1="34" y1="180" x2="390" y2="180"/></g>' +
      '<g fill="#6B7686">' + ticks.map(function (t) { return '<text x="0" y="' + (y(t) + 4) + '">' + t + (hasGoal ? '' : '%') + '</text>'; }).join('') +
      '<text x="34" y="204">Днес</text><text x="212" y="204" text-anchor="middle">' + Math.round(weeks / 2) + ' седм.</text><text x="390" y="204" text-anchor="end">' + weeks + ' седм.</text></g>' +
      '<path d="M34 ' + y0 + ' C120 ' + (y0 - 2) + ' 250 ' + (yf + 1) + ' 390 ' + yf + '" fill="none" stroke="#AFC0D4" stroke-width="3" stroke-dasharray="6 6"/>' +
      '<path d="M34 ' + y0 + ' C110 ' + (y0 + 20) + ' 190 ' + (y1 - 30) + ' 390 ' + y1 + '" fill="none" stroke="#3480D4" stroke-width="4" stroke-linecap="round"/>' +
      '<circle cx="34" cy="' + y0 + '" r="6" fill="#fff" stroke="#1B2230" stroke-width="3"/><circle cx="390" cy="' + y1 + '" r="7" fill="#E4B54A" stroke="#1B2230" stroke-width="3"/>' +
      '<g font-weight="700"><text x="300" y="' + (yf - 8) + '" fill="#6B7686">без промяна</text><text x="372" y="' + Math.min(178, y1 + 24) + '" text-anchor="end" fill="#2668B3">' + (hasGoal ? 'с плана: ' + tgt + ' кг' : 'с плана') + '</text></g></svg>';
  }

  /* ---------- navigation ---------- */
  function show(i, dir) {
    if (loaderTimer) { clearTimeout(loaderTimer); loaderTimer = null; }
    var s = S[i]; st.i = i; save();
    root.setAttribute('data-screen-type', s.type);
    root.classList.toggle('is-back', dir < 0);
    var el = document.createElement('section');
    el.className = 'spq-screen' + (cur ? ' is-entering' : ' is-active');
    el.setAttribute('data-id', s.id);
    el.innerHTML = build(s);
    var old = cur; cur = el;
    if (old) {
      old.classList.remove('is-active'); old.classList.add('is-leaving');
      setTimeout(function () { old.remove(); stage.appendChild(el); window.scrollTo(0, 0); requestAnimationFrame(function () { el.classList.add('is-active'); }); setTimeout(function () { el.classList.remove('is-entering'); }, 240); }, 160);
    } else stage.appendChild(el);
    var LI = S.findIndex(function (x) { return x.type === 'loader'; }), tot = 0, n = 0;
    S.forEach(function (x, k) { if (k >= LI || !countable(k)) return; tot++; if (k <= i) n++; });
    var after = i >= LI;
    var pwrap = root.querySelector('.spq-progress');
    if (pwrap && pwrap.style) pwrap.style.visibility = after ? 'hidden' : '';
    if (count.style) count.style.visibility = after ? 'hidden' : '';
    prog.style.width = Math.max(4, Math.round(n / tot * 100)) + '%';
    count.textContent = Math.min(n, tot) + '/' + tot;
    back.hidden = i === 0 || s.type === 'loader';
    // footer CTA
    var auto = s.type === 'single' || s.type === 'photo' || s.type === 'loader';
    bar.hidden = auto;
    cta.textContent = tx(s.cta || 'Продължи →');
    cta.disabled = s.type === 'multi' && !(st.a[s.id] || []).length;
    if (s.type === 'input') bindInput(s, el);
    if (s.type === 'loader') runLoader(el);
    if (s.type === 'result') track('spq_complete');
    preload(step(i, 1));
  }
  function go(i, dir) {
    if (busy || i < 0 || i >= S.length) return;
    busy = true; setTimeout(function () { busy = false; }, 420);
    if (dir > 0) try { if (S[st.i] && S[st.i].type === 'loader') history.replaceState({ spq: i }, ''); else { history.pushState({ spq: i }, ''); depth++; } } catch (e) {}
    show(i, dir);
  }
  function next() {
    var s = S[st.i];
    if (s.type === 'input' && !validate(s, true)) return;
    var k = step(st.i, 1);
    if (k >= S.length) return finish();
    go(k, 1);
  }
  function preload(i) {
    var s = S[i]; if (!s || !s.options) return;
    s.options.forEach(function (o) { if (o.img) { var im = new Image(); im.src = typeof o.img === 'object' ? o.img[gender()] : o.img; } });
  }

  /* ---------- inputs ---------- */
  function bindInput(s, el) {
    var live = el.querySelector('.spq-live');
    el.querySelectorAll('.spq-input').forEach(function (inp) {
      inp.addEventListener('input', function () {
        inp.value = inp.value.replace(/\D/g, '').slice(0, 3);
        var v = st.a[s.id] || {}; v[inp.dataset.k] = inp.value; st.a[s.id] = v; save();
        inp.closest('.spq-fields').classList.remove('has-error');
        if (live) updateLive(live);
      });
      inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); next(); } });
    });
    if (live) updateLive(live);
    var first = el.querySelector('.spq-input'); if (first && !first.value && window.matchMedia('(pointer:fine)').matches) setTimeout(function () { first.focus(); }, 300);
  }
  function updateLive(p) {
    var d = calc();
    p.textContent = !d.goal || d.goal < 40 ? '' : d.diff > 0 ? 'Това е с ' + d.diff + ' кг по-малко от сегашните ' + d.kg + ' кг.' : d.diff === 0 ? 'Целта ти е да задържиш теглото и да овладееш изкушенията.' : '';
  }
  function validate(s, mark) {
    var ok = true, v = st.a[s.id] || {}, d = calc();
    s.fields.forEach(function (f) {
      var n = +v[f.k], box = cur.querySelector('.spq-fields[data-k="' + f.k + '"]'), msg = f.err, bad = !n || n < f.min || n > f.max;
      if (!bad && f.bmiFloor && d.h && n < 18.5 * Math.pow(d.h / 100, 2)) { bad = true; msg = tx(f.errLow); }
      if (!bad && f.errHigh && d.kg && n > d.kg) { bad = true; msg = tx(f.errHigh); }
      if (mark && box) box.querySelector('.spq-field__error').textContent = msg;
      if (bad) { ok = false; if (mark && box) box.classList.add('has-error'); }
    });
    return ok;
  }

  /* ---------- loader ---------- */
  function runLoader(el) {
    var ring = el.querySelector('.spq-ring'), pct = el.querySelector('.spq-ring__pct'), steps = el.querySelectorAll('.spq-step'), p = 0;
    var holds = { 74: 500, 99: 250 }; // short stops so it feels like real work
    function tick() {
      p = Math.min(100, p + (p < 70 ? 2 : 1));
      ring.style.setProperty('--p', p); pct.textContent = p + '%';
      var k = Math.min(steps.length - 1, Math.floor(p / (100 / steps.length)));
      steps.forEach(function (x, j) { x.classList.toggle('is-done', j < k || p === 100); x.classList.toggle('is-active', j === k && p < 100); });
      if (p >= 100) { loaderTimer = null; setTimeout(function () { go(step(st.i, 1), 1); }, 600); return; }
      loaderTimer = setTimeout(tick, 45 + (holds[p] || 0));
    }
    loaderTimer = setTimeout(tick, 45);
  }

  /* ---------- finish → offer page ---------- */
  function finish() {
    var d = calc();
    var out = { g: gender(), type: d.type, typeName: C.types[d.type].name, level: d.level.key, pct: d.gpct, weeks: planWeeks(d), stage: planStage(d),
      kg: d.kg, goal: d.goal, diff: d.diff, bmi: d.bmi ? Math.round(d.bmi * 10) / 10 : 0,
      when: (opt('when', st.a.when) || {}).t || '', tempt: (opt('tempt', st.a.tempt) || {}).t || '', at: Date.now() };
    try { sessionStorage.setItem(OUT, JSON.stringify(out)); localStorage.setItem(OUT, JSON.stringify(out)); } catch (e) {}
    track('spq_to_offer');
    location.href = C.offerUrl;
  }

  /* ---------- events ---------- */
  stage.addEventListener('click', function (e) {
    var b = e.target.closest('.spq-opt'); if (!b || busy) return;
    var s = S[st.i], v = b.dataset.v;
    if (st.i === 0 && !st.started) { st.started = 1; track('spq_start'); }
    if (s.type === 'multi') {
      var o = opt(s.id, v), arr = (st.a[s.id] || []).slice(), at = arr.indexOf(v);
      if (at > -1) arr.splice(at, 1);
      else if (o.x) arr = [v];
      else { arr = arr.filter(function (x) { var y = opt(s.id, x); return !(y && y.x); }); arr.push(v); }
      st.a[s.id] = arr; save();
      cur.querySelectorAll('.spq-opt').forEach(function (n) { var on = arr.indexOf(n.dataset.v) > -1; n.classList.toggle('is-selected', on); n.setAttribute('aria-checked', on); });
      cta.disabled = !arr.length;
      return;
    }
    st.a[s.id] = v;
    S.forEach(function (x) { var c = st.a[x.id]; if (!x.options || c == null || Array.isArray(c)) return; var o = opt(x.id, c); if (o && !okIf(o.if)) delete st.a[x.id]; });
    save();
    cur.querySelectorAll('.spq-opt').forEach(function (n) { var on = n === b; n.classList.toggle('is-selected', on); n.setAttribute('aria-checked', on); });
    setTimeout(next, 260);
  });
  cta.addEventListener('click', next);
  back.addEventListener('click', function () {
    if (st.i <= 0 || busy) return;
    if (depth > 0) return history.back();
    var j = step(st.i, -1); if (S[j] && S[j].type === 'loader') j = step(j, -1); show(Math.max(0, j), -1);
  });
  window.addEventListener('popstate', function (e) {
    depth = Math.max(0, depth - 1);
    var i = e.state && typeof e.state.spq === 'number' ? e.state.spq : 0;
    if (S[i] && S[i].type === 'loader') i = Math.max(0, step(i, -1));
    if (i !== st.i) show(i, i < st.i ? -1 : 1);
  });

  // test hook (only with ?spqdebug in the URL): lets the audit script render every screen for any answers
  if (/[?&]spqdebug/.test(location.search)) window.SPQ_DEBUG = { st: st, S: S, calc: calc, build: build, visible: visible, tx: tx, opt: opt };

  // resume where the visitor left off (except mid-loader)
  if (S[st.i] && S[st.i].type === 'loader') st.i = step(st.i, 1);
  try { history.replaceState({ spq: st.i }, ''); } catch (e) {}
  show(st.i, 1);
})();
